if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.querySelector('[data-cart-discount-form]');
        this.input = this.querySelector('[data-cart-discount-input]');
        this.button = this.querySelector('[data-cart-discount-submit]');
        this.message = this.querySelector('[data-cart-discount-message]');

        this.form?.addEventListener('submit', this.onSubmit);
      }

      async onSubmit(event) {
        event.preventDefault();

        const code = this.input?.value.trim();
        if (!code) {
          this.showMessage(this.dataset.emptyMessage, true);
          this.input?.focus();
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer?.getSectionsToRender().map((section) => section.section || section.id) || [
          'cart-drawer',
          'cart-icon-bubble',
        ];

        this.setLoading(true);
        this.showMessage('');

        try {
          const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              discount: code,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();

          if (!response.ok || state.errors) throw new Error(state.description || state.message || state.errors);

          const normalizedCode = code.toLowerCase();
          const codeStatuses = Array.isArray(state.discount_codes) ? state.discount_codes : [];
          const cartApplications = Array.isArray(state.cart_level_discount_applications)
            ? state.cart_level_discount_applications
            : [];
          const lineApplications = (state.items || []).flatMap((item) => item.line_level_discount_allocations || []);
          const applicationTitles = [...cartApplications, ...lineApplications.map((allocation) => allocation.discount_application)]
            .map((application) => application?.title?.toLowerCase())
            .filter(Boolean);
          const codeStatus = codeStatuses.find(
            (discountCode) => discountCode.code?.toLowerCase() === normalizedCode,
          );
          const isApplied = codeStatus?.applicable === true || applicationTitles.includes(normalizedCode);

          if (!isApplied) throw new Error(this.dataset.errorMessage);

          if (cartDrawer && state.sections) cartDrawer.renderContents(state);

          requestAnimationFrame(() => {
            const updatedDiscount = document.querySelector('cart-discount');
            updatedDiscount?.showMessage(updatedDiscount.dataset.successMessage, false);
          });
        } catch (error) {
          console.error(error);
          this.showMessage(this.dataset.errorMessage, true);
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.disabled = isLoading;
        this.button.classList.toggle('loading', isLoading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }

      showMessage(text, isError = false) {
        if (!this.message) return;
        this.message.textContent = text || '';
        this.message.classList.toggle('is-error', Boolean(text) && isError);
        this.message.classList.toggle('is-success', Boolean(text) && !isError);
      }
    },
  );
}
